import axios from 'axios';
import { ErrorType } from './ActionType';
import AppConfig from '../config';

const API_URL = AppConfig.API_URL;

const formDataHeader = {
  'Accept': 'application/x-www-form-urlencoded',
  "Content-Type": "application/x-www-form-urlencoded",
  "cache-control": "no-cache",
};



export const getJobSubscriptionPackage = (type, callback, packageType) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/JobSubscriptionPackage/${type}`)
      .then((res) => {
        if (res) {
          callback(res.data, packageType)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const postJobSubscriptionPackage = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/JobSubscriptionPackage`, data)
      .then((res) => {
        callback(res.data, 'Job Subscription Package Added')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateJobSubscriptionPackage = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/JobSubscriptionPackage/${id}`, data)
      .then((res) => {
        callback(res.data, 'Job Subscription Package Updated')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getJobAlertPackage = (type, callback, packageType) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/jobAlertPackage/${type}`)
      .then((res) => {
        if (res) {
          callback(res.data, packageType)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};


export const postJobAlertPackage = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/jobAlertPackage`, data)
      .then((res) => {
        callback(res.data, 'Job Alert Package Added')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};


export const getTaskSubscriptionPackage = (type, callback, packageType) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/TaskSubscriptionPackage/${type}`)
      .then((res) => {
        if (res) {
          callback(res.data, packageType)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const postTaskSubscriptionPackage = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/TaskSubscriptionPackage`, data)
      .then((res) => {
        callback(res.data, 'Task Subscription Package Added')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};


export const updateTaskSubscriptionPackage = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/TaskSubscriptionPackage/${id}`, data)
      .then((res) => {
        callback(res.data, 'Task Subscription Package Updated')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getTaskAlertPackage = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/TaskAlertPackage`)
      .then((res) => {
        if (res) {
          callback(res.data)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const postTaskAlertPackage = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/TaskAlertPackage`, data)
      .then((res) => {
        callback(res.data, 'Task Alert Package Added')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getMemberSubscriptionPackage = (type, callback, packageType) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/MemberSubscriptionPackage/${type}`)
      .then((res) => {
        if (res) {
          callback(res.data, packageType)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const postMemberSubscriptionPackage = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/MemberSubscriptionPackage`, data)
      .then((res) => {
        callback(res.data, 'Member Subscription Package Added')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};


export const updateMemberSubscriptionPackage = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/MemberSubscriptionPackage/${id}`, data)
      .then((res) => {
        callback(res.data, 'Member Subscription Package Updated')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getMemberAlertPackage = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/MemberAlertPackage`)
      .then((res) => {
        if (res) {
          callback(res.data)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const postMemberAlertPackage = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/MemberAlertPackage`, data)
      .then((res) => {
        callback(res.data, 'Member Alert Package Added')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getOffices = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/offices`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};
export const postOffice = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/offices`, data)
      .then((res) => {
        callback(res.data.result, 'office Added')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getPartners = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/partners`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};
export const postPartner = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/partners`, data)
      .then((res) => {
        callback(res.data.result, 'Partner Added')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};


export const getTestimonials = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/testimonials`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};
export const postTestimonial = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/testimonials`, data)
      .then((res) => {
        callback(res.data.result, 'Comments Added')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateTestimonial = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/testimonials/${id}`, data)
      .then((res) => {
        callback(res.data.result, 'Comments updated')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getNews = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/news`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getFirstThreeNews = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/news/firstThree`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const postNews = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/news`, data)
      .then((res) => {
        callback(res.data.result, 'news Added')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateNews = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/news/${id}`, data)
      .then((res) => {
        callback(res.data.result, 'news updated')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getCustomers = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/customers`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};
export const postCustomer = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/customers`, data)
      .then((res) => {
        callback(res.data.result, 'Customer Added')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};
export const getIssueLogs = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/issueLogs`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getIssueLogsByUser = (user, callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/issueLogs/${user}`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const postIssueLog = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/issueLogs`, data)
      .then((res) => {
        callback(res.data.result, 'Issue Log Added')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateIssueLog = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/issueLogs/${id}`, data)
      .then((res) => {
        callback(res.data.result, 'Issue Log Updated')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getOtherTranslations = (callback) => {

  axios.get(`${API_URL}/translations`)
    .then((res) => {
      if (res) {
        callback(res.data)
      }
    })
    .catch((err) => {

    });
};

export const getFaq = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/faq`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const postFaq = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/faq`, data)
      .then((res) => {
        callback(res.data.result, 'Faq Added')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateFaq = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/faq/${id}`, data)
      .then((res) => {
        callback(res.data.result, 'Faq Updated')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const deleteFaq = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/faq/deleteFAQ`, data)
      .then((res) => {
        callback(res.data.result, 'Faq Deleted')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};



export const getWhatPeopleSays = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/whatPeopleSays`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const postWhatPeopleSays = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/whatPeopleSays`, data)
      .then((res) => {
        callback(res.data.result, 'What People Says Added')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateWhatPeopleSays = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/whatPeopleSays/${id}`, data)
      .then((res) => {
        callback(res.data.result, 'What People Says Updated')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const deleteWhatPeopleSays = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/whatPeopleSays/deleteWhatPeopleSays`, data)
      .then((res) => {
        callback(res.data.result, 'What People Says Deleted')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const sendJobAlerts = (callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/admins/sendJobAlerts`)
      .then((res) => {
        if (res) {
          callback(res.data)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};


export const sendContactUs = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/contactUs`, data)
      .then((res) => {
        if (res) {
          callback(res.data)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

// ----------------- disputes ----------------- //

export const getDisputes = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/disputes/getAllDisputes`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateDisputes = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/disputes/${id}`, data)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};


// ----------------- Resume Download Admin ----------------- //

export const getResumeDownloadSubscriptionPackage = (type, callback, packageType) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/resumeDownloadSubscriptionPackage/${type}`)
      .then((res) => {
        if (res) {
          callback(res.data, packageType)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const postResumeDownloadSubscriptionPackage = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/resumeDownloadSubscriptionPackage`, data)
      .then((res) => {
        callback(res.data, 'Resume Download Subscription Package Added')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateResumeDownloadSubscriptionPackage = (id, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/resumeDownloadSubscriptionPackage/${id}`, data)
      .then((res) => {
        callback(res.data, 'Resume Download Subscription Package Updated')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

// ----------------- Resume Download Business ----------------- //

export const getResumeDownloadSubscription = (user, type, callback, packageType) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/resumeDownloadPackageMapping/${user}/${type}`)
      .then((res) => {
        if (res) {
          callback(res.data, packageType)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const postResumeDownloadSubscription = (data, callback, packageType) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/resumeDownloadPackageMapping`, data)
      .then((res) => {
        callback(res.data, packageType, 'Subscription Added')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

// ----------------- Report Abuse ----------------- //

export const getReportAbuse = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/reportAbuse/`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getReportAbuseByUser = (user, callback, ) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/reportAbuse/reportAbuseByUser/${user}`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const postReportAbuse = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/reportAbuse`, data, { headers: formDataHeader })
      .then((res) => {
        callback(res.data.result, 'Report Abuse Added')
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

// ----------------- Admin Batches ----------------- //

export const removeTaskDocuments = (callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/admins/removeTaskDocuments`)
      .then((res) => {
        if (res) {
          callback(res.data)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};


export const getAboutUsDetails = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/admin/getAboutUs`)
      .then((res) => {
        if (res) {
          callback(res.data)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

// ---------- Teams ---------- //

export const addTeam = (data, callback) => {
  return function (dispatch) {
    return axios.post(`${API_URL}/teams`, data, { headers: formDataHeader })
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const updateTeam = (id, name, data, callback) => {
  return function (dispatch) {
    return axios.put(`${API_URL}/teams/${id}?filename=${name}`, data, { headers: formDataHeader })
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getTeams = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/teams`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getActiveTeams = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/teams/getActiveTeams`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getMedicinePageTeams = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/teams/getMedicinePageTeams`)
      .then((res) => {
        if (res) {
          console.log(res.data.result)
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};

export const getMainPageTeams = (callback) => {
  return function (dispatch) {
    return axios.get(`${API_URL}/teams/getMainPageTeams`)
      .then((res) => {
        if (res) {
          callback(res.data.result)
        }
      })
      .catch((err) => {
        dispatch({ type: ErrorType.ERROR_LOG, payload: err });
      });
  };
};


// WEBPACK FOOTER //
// ./actions/AdminActions.js